import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { MatFormFieldControl } from '@angular/material';
import { AbstractMatFormFieldControl } from '@mctic/ng-core';
import { debounceTime, distinctUntilChanged, filter, startWith, switchMap } from 'rxjs/operators';
import { PessoaJuridicaService } from '../../../service';
import { PessoaJuridica } from '../../model';

@Component({
  selector: 'app-input-cnpj',
  template: '<input matInput [formControl]="formControl" mask="00.000.000/0000-00">',
  styleUrls: ['./input-cnpj.component.scss'],
  providers: [{provide: MatFormFieldControl, useExisting: InputCnpjComponent}]
})
export class InputCnpjComponent extends AbstractMatFormFieldControl<PessoaJuridica> implements OnInit {

  @Input()
  habilitaPesquisa: boolean = true;

  @Output()
  pesquisar: EventEmitter<PessoaJuridica> = new EventEmitter<PessoaJuridica>();

  private readonly pessoaJuridicaService: PessoaJuridicaService;

  constructor(injector: Injector) {
    super(injector);
    this.pessoaJuridicaService = injector.get(PessoaJuridicaService);
  }

  ngOnInit(): void {
    super.ngOnInit();

    if (this.habilitaPesquisa) {
      this.setPesquisaCorporativo();
    }
  }

  private setPesquisaCorporativo() {
    this.formControl.valueChanges.pipe(
      startWith(''),
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => this.formControl.valid && value && value.length === 14),
      switchMap(value => this.pessoaJuridicaService.consultarPorCnpj(value))
    ).subscribe(value => this.pesquisar.emit(value));
  }

}
